import { useCallback } from 'react';

function fallbackCopyTextToClipboard(text: string) {
  const textArea = document.createElement("textarea");
  textArea.value = text;

	// Add invisible styles
  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';
	textArea.style.width = '0';
	textArea.style.height = '0';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

	// Copy selected text from textarea
	document.execCommand('copy');

  document.body.removeChild(textArea);
}

const useClipboard = () => {
	const copyTextToClipboard = useCallback(async (text) => {
		try {
			if ('clipboard' in navigator) {
				await navigator.clipboard.writeText(text);
			} else {
				fallbackCopyTextToClipboard(text);
			}
		} catch (error) {
			return null;
		}
	}, []);

	return {
		copyTextToClipboard,
	};
};

export default useClipboard;
